import axios from "axios";

const siteUrl = window.localStorage.getItem("siteURL");
const baseURL = siteUrl ? `${siteUrl}/wp-json/cynapi/v1` : "/wp-json/cynapi/v1";

const AxiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default AxiosInstance;